import React from 'react'
import Privacy_policy from '../components/privacy/pri_policy/privacy_policy'
import Terms from '../components/privacy/termscondition/terms'

const Privacy = () => {
  return (
    <div>
      <Privacy_policy />
    </div>
  )
}

export default Privacy
